(function(){
const mag=document.getElementById('ftf-mag');
if(!mag) return;
document.body.classList.add('ftfm-active'); // :has() fallback for FIX 2 header/footer hide
const pgs=[...mag.querySelectorAll('.ftfm-pg')];
const dotsWrap=document.querySelector('.ftfm-dots');
// dot count follows the actual number of pages rendered from blocks (ponytail: build
// dots in JS instead of hand-authoring one <i> per block in the section — the page
// count differs per template, so the dot row has to be derived, not fixed markup)
if(dotsWrap){
  dotsWrap.innerHTML='';
  pgs.forEach(()=>{const i=document.createElement('i');dotsWrap.appendChild(i);});
}
const dots=dotsWrap?[...dotsWrap.querySelectorAll('i')]:[];
if(dots[0]) dots[0].classList.add('ftfm-on');
// Warm the NEXT page's photo as this page becomes the current one.
// loading="lazy" buys only the browser's own lookahead (measured: about two page
// heights at 1440x900), and on a snap pager one flick is one whole page, so a reader
// who flicks steadily outruns it and lands on a grey box while the fetch starts.
// Flipping the next page's <img> to eager starts that fetch one flick earlier.
// Hover swaps are deliberately excluded: they are invisible until hover, so warming
// them would only take bandwidth from the photo the reader is actually waiting on.
// ponytail: one attribute flip on one <img>, not a preloader. If one page of lead is
// still not enough, warm pgs[i+2] here too before reaching for anything bigger.
const warm=i=>{const n=pgs[i+1];if(n)n.querySelectorAll('img[loading="lazy"]:not(.ftfm-swap)').forEach(im=>{im.loading='eager';});};
warm(0);
// root omitted (defaults to the browser viewport): correct on both breakpoints because
// IntersectionObserver clips its root by ancestor overflow, and .ftfm-mag is now the
// scroller on both — position:fixed;inset:0 in ftf-magazine.css, so its viewport IS
// the browser viewport either way.
const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){const i=pgs.indexOf(e.target);dots.forEach((d,j)=>d.classList.toggle('ftfm-on',j===i));warm(i);}}),{threshold:.55});
pgs.forEach(p=>io.observe(p));
// URL-bar tap-to-scroll-top replacement (mobile only, Aug 14) — see the button's
// own comment in ftf-magazine.liquid and the .ftfm-totop rule in ftf-magazine.css
// for why this exists. Explicit behaviour check rather than relying on
// .ftfm-mag's CSS scroll-behavior, which scrollIntoView's own `behavior` option
// overrides regardless of the stylesheet.
const totop=document.getElementById('ftfm-totop');
if(totop && pgs[0]){
  totop.addEventListener('click',()=>{
    const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
    pgs[0].scrollIntoView({behavior:reduce?'auto':'smooth'});
  });
}
dots.forEach((d,i)=>d.addEventListener('click',()=>pgs[i].scrollIntoView({behavior:'smooth'})));
addEventListener('keydown',e=>{const c=dots.findIndex(d=>d.classList.contains('ftfm-on'));
 if(e.key==='ArrowDown'||e.key===' '){e.preventDefault();pgs[Math.min(c+1,pgs.length-1)].scrollIntoView({behavior:'smooth'});}
 if(e.key==='ArrowUp'){e.preventDefault();pgs[Math.max(c-1,0)].scrollIntoView({behavior:'smooth'});}});

// REMOVED (iOS Safari mid-scroll bleed + stutter, Aug 14): the measure()/paint() split,
// the resize listener and the pageshow/persisted re-pin that used to live here. All of
// it existed to keep a JS-measured --ftfm-slot/--ftfm-slack pair in step with the
// document's collapsing/expanding URL-bar viewport. ftf-magazine.css no longer makes
// the document the scroller — .ftfm-mag is position:fixed;inset:0, sized from the
// layout viewport, which does not change size as browser chrome animates — so there is
// nothing left to measure or re-pin. See the long comment on .ftfm-mag in
// ftf-magazine.css for the full root-cause writeup.

// on-model photo swap: hover on desktop, first tap on mobile (overview cards +,
// as of Aug 14, every category/feature/teaser page's .ftfm-media — same markup
// pattern (base img + img.ftfm-swap), same tap-to-reveal-then-tap-to-follow
// behaviour on touch. e.preventDefault() on the bubbled click still blocks the
// <a> inside .ftfm-media from navigating on the reveal tap.
// FIX (light-tap swap misses, Aug 18): the reveal used to hang off `click` alone,
// and mobile browsers cancel click synthesis when the finger drifts even a few px
// between touchstart and touchend — so a light single tap often did nothing and
// the owner had to "double tap lightly". The swap now fires on touchend itself
// when the gesture was a real tap (moved < 12px, held < 500ms); the click handler
// stays as-is for browsers/inputs that never fire touch events, with a consumed
// flag so a synthetic click after our touchend can't double-fire. Second tap
// still navigates: once .ftfm-tapped is set, touchend does nothing and the
// bubbled click on the <a> proceeds. Desktop hover path untouched.
document.querySelectorAll('.ftfm-cell, .ftfm-media').forEach(cell=>{
  if(!cell.querySelector('img.ftfm-swap')) return;
  let t0=null, consumed=false;
  cell.addEventListener('touchstart',e=>{
    consumed=false; // any new touch clears the last reveal's click guard
    const t=e.changedTouches[0];
    t0={x:t.clientX,y:t.clientY,ts:Date.now()};
  },{passive:true});
  cell.addEventListener('touchend',e=>{
    if(!t0) return;
    const t=e.changedTouches[0];
    const moved=Math.hypot(t.clientX-t0.x,t.clientY-t0.y);
    const dur=Date.now()-t0.ts;
    t0=null;
    if(moved<12 && dur<500 && !cell.classList.contains('ftfm-tapped')){
      if(e.cancelable) e.preventDefault(); // suppress the synthetic click for this reveal tap
      cell.classList.add('ftfm-tapped');
      consumed=true;
    }
  });
  cell.addEventListener('click',e=>{
    if(consumed){consumed=false;e.preventDefault();return;} // reveal already handled on touchend
    if(matchMedia('(hover:hover)').matches) return;
    if(!cell.classList.contains('ftfm-tapped')){e.preventDefault();cell.classList.add('ftfm-tapped');}
  });
});

// FILTER pill overlay (SWEEP Aug 14: aria-expanded, Esc-to-close, a Tab loop that
// stays inside the panel while open, and focus returned to the pill on close —
// none of that existed before; only the open/close class toggle did.)
const pill=document.querySelector('.ftfm-filter-pill');
const overlay=document.querySelector('.ftfm-filter-overlay');
if(pill && overlay){
  const closeBtn=overlay.querySelector('.ftfm-filter-close');
  const openOverlay=()=>{
    overlay.classList.add('ftfm-open');
    pill.setAttribute('aria-expanded','true');
    (closeBtn||overlay).focus();
  };
  const closeOverlay=()=>{
    overlay.classList.remove('ftfm-open');
    pill.setAttribute('aria-expanded','false');
    pill.focus();
  };
  pill.addEventListener('click',openOverlay);
  closeBtn?.addEventListener('click',closeOverlay);
  overlay.addEventListener('click',e=>{if(e.target===overlay) closeOverlay();});
  overlay.querySelectorAll('a').forEach(a=>a.addEventListener('click',closeOverlay));
  // one document-level listener, gated on the open class, rather than
  // attaching/detaching per open/close — simpler and the check is nearly free.
  document.addEventListener('keydown',e=>{
    if(!overlay.classList.contains('ftfm-open')) return;
    if(e.key==='Escape'){closeOverlay();return;}
    if(e.key!=='Tab') return;
    const items=[...overlay.querySelectorAll('a,button')].filter(el=>el.offsetParent);
    if(!items.length) return;
    const first=items[0], last=items[items.length-1];
    if(e.shiftKey && document.activeElement===first){e.preventDefault();last.focus();}
    else if(!e.shiftKey && document.activeElement===last){e.preventDefault();first.focus();}
  });
}
})();
